<template>
  <div class="dialog">
    <el-dialog :visible.sync="changVisible" title="新增校友会照片" center style="padding: 10px" width="550px" :before-close="$onClose" destroy-on-close @close="close()">
      <input type="file" accept="image/*" style="display: none" id="uploadfile" @change="openFolder" />
      <el-image class="imageDiv" :src="imageUrl" fit="scale-down" style="width: 450px; height: 300px">
        <div slot="error" class="image-slot" style="position: absolute; top: 50%; left: 50%">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <div class="foot">
        <el-button size="mini" @click="openImage()">选择本地图片</el-button>
        <el-button style="float: right" size="small" type="primary" v-preventReClick @click="save()">保存</el-button>
        <el-button style="float: right; margin-right: 15px" size="small" @click="close()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isEmpty } from '@/utils/strUtils'
import preventReClick from '@/utils//preventReClick' //防多次点击，重复提交
import * as Constant from '@/utils/constant.js'
import * as Api from '@/api/api.js'

export default {
  data() {
    return {
      changVisible: false,
      imageUrl: ''
    }
  },
  methods: {
    $onClose(done) {
      done()
    },
    close() {
      this.changVisible = false
      this.imageUrl = ''
      this.association_id = ''
      this.image = null
    },
    save() {
      let clickNow = new Date().valueOf()
      if (clickNow - this.clickLastTime < 2000) return
      this.clickLastTime = clickNow
      this.addImage()
    },
    //页面初始化时加载的事件
    show(id) {
      this.association_id = id
      this.changVisible = true
    },
    // 选择图片
    openImage() {
      document.getElementById('uploadfile').click()
    },
    openFolder(e) {
      var that = this
      var image = e.target.files[0]
      var reader = new FileReader()
      reader.onload = function (evt) {
        that.imageUrl = evt.target.result
      }
      reader.readAsDataURL(image)
      this.image = image
    },
    // 新增
    addImage() {
      if (this.image == null) {
        this.$message.error('请先选择图片')
        return
      }
      var form = new FormData()
      form.append('token', localStorage.getItem('token'))
      form.append('association_id', this.association_id)
      form.append('image', this.image)
      this.$api
        .addAssociationImage(form)
        .then(({ data }) => {
          this.$emit('toSave')
          this.close()
        })
        .catch(({ error }) => {})
    }
  }
}
</script>

<style lang="less" scoped>
.foot {
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  // padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/addAssociationImageDialog.vue